import { Component, Input, OnInit } from '@angular/core';
import { MenuItem } from 'primeng/api';
import { UtilsService } from '../../../../services/utils.service';
import { BreadCrumsConstant } from './breadcrumb.constants';
import { Router, RouterModule } from '@angular/router';
import { USER_MGMT_CNST } from '../../../../constants/proj.cnst';
import { AppStateService } from '../../../../services/app-state.service';
import { BreadcrumbModule } from 'primeng/breadcrumb';
import { ImportsModule } from '../../../imports/imports';
import { CommonModule } from '@angular/common';


@Component({
  selector: 'app-primeng-breadcrumb',
  templateUrl: './primeng-breadcrumb.component.html',
  imports : [
    BreadcrumbModule,
    RouterModule,
    CommonModule
  ]
})
export class PrimengBreadcrumbComponent implements OnInit {
  loggedInUserType!: string;
  loggedInUser: typeof USER_MGMT_CNST.LOGGED_IN_USER_TYPES = USER_MGMT_CNST.LOGGED_IN_USER_TYPES;

  @Input() breadcrumbData!: MenuItem[] | undefined;

  constructor(
    private utils: UtilsService,
    private appStateService: AppStateService,
    public router: Router,
  ) { }

  ngOnInit() {
    this.onInItMethod();
    this.initializeBreadCrumb();
    this.onApplicationChange()
  }

  onInItMethod() {
    this.loggedInUserType = this.appStateService.getLoggedInUserType();

  }

  /**
 * Handles the application change event by fetching the latest application details.
 * If the application data is available, it updates the organization and application names.
 */
  onApplicationChange() {
    this.appStateService.getApplicationDetails().subscribe((app: any) => {
      if (app) {
        this.updateOrgNameAndAppName();
      }
    })
  }

  //Updates breadcrumb data based on the current URL.
  changeBreadCrumbDataBasedOnUrl(currentUrl: string, targetValue?: string, urlParts?: any) {
    switch (currentUrl) {
      case '/configuration/knowledgebase/home':
        this.breadcrumbData = BreadCrumsConstant['knowledgebase'];
        break;

      case '/configuration/channels/chat':
        this.breadcrumbData = BreadCrumsConstant['Channelchat'];
        break;

      case '/home/app':
        this.breadcrumbData = BreadCrumsConstant['app'];
        if (this.loggedInUserType === this.loggedInUser.superAdmin) {
          this.breadcrumbData = [  { label: 'Home', routerLink: '/home' }, { label: 'Applications' }];
        }
        break;

      case '/ticket-dashboard/email/email-ticket':
        this.breadcrumbData = BreadCrumsConstant['Dashboardemail'];
        this.breadcrumbData[0].queryParams = {
              applicationId: this.appStateService.getApplicationInfo()?.applicationId
        }
        break;

        case '/ticket-dashboard/merged-ticket/merged':
          this.breadcrumbData = BreadCrumsConstant['Dashboardemail'];
          this.breadcrumbData[0].queryParams = {
              applicationId: this.appStateService.getApplicationInfo()?.applicationId
        }
          break;

      case '/ticket-dashboard/chat':
        this.breadcrumbData = BreadCrumsConstant['Dashboardchat'];
        this.breadcrumbData[0].queryParams = {
              applicationId: this.appStateService.getApplicationInfo()?.applicationId
        }
        break;

      case '/ticket-dashboard':
        this.breadcrumbData = BreadCrumsConstant['dashboard'];
        break;

      case '/configuration/wiseflow-tools':
        this.breadcrumbData = BreadCrumsConstant['wiseflowtools'];
        break;

      case '/usermgmt/users/config':
        this.breadcrumbData = BreadCrumsConstant['userconfig'];
        break;
      case '/user-activity/profile':
        this.breadcrumbData = BreadCrumsConstant['userProfile'];
        this.breadcrumbData[0].queryParams = {
              applicationId: this.appStateService.getApplicationInfo()?.applicationId
        }
        break;
      
      case '/configuration/knowledgebase/compliance': 
        this.breadcrumbData = BreadCrumsConstant['Compliance'];
        break;
      case '/configuration/wiseflow/flow/newflow':
        this.breadcrumbData = BreadCrumsConstant['wiseflow'];
        break;
      case '/configuration/wiseflow/events/edit-inactivity':
        this.breadcrumbData = BreadCrumsConstant['editinactivity']
        break
      default:{ 
          const lastElement = targetValue === 'not-allowed' ? 'allowed' : urlParts[urlParts.length - 1];
          this.breadcrumbData = (lastElement === 'add-llm' || lastElement === 'assign-organizations'  || lastElement === 'customers' || lastElement === 'report' || lastElement === 'compare')
            ? this.breadcrumbData
            : BreadCrumsConstant[lastElement] || [];
            this.breadcrumbData?.forEach((crumb: MenuItem)=>{
              if(crumb.label === 'Knowledge Base') {
                crumb.queryParams = {
                  applicationId: this.appStateService.getApplicationInfo()?.applicationId
                }
              }
            })
          break;
      }  
  }
}

/**
 * Initializes the breadcrumb based on the current URL.
 * - Extracts the URL parts and identifies the target value.
 * - Calls a method to update breadcrumb data based on the URL.
 * - Removes the 'Applications' breadcrumb item for non-super admin users,
 *   unless the URL contains 'applications/assignResource'.
 */
  initializeBreadCrumb() {
    const currentUrl = this.router?.url?.split('?')[0]?.split('#')[0];
    const urlParts = currentUrl ? currentUrl?.split('/') : []; // Split the URL into parts
    const targetValue = urlParts[urlParts?.length - 1] ?? 0;
    this.changeBreadCrumbDataBasedOnUrl(currentUrl, targetValue, urlParts);
    const userListItems = this.breadcrumbData?.find((item: MenuItem) => item.label === 'Applications');
    if (this.loggedInUserType !== this.loggedInUser.superAdmin && userListItems && !this.router.url?.includes('applications/assignResource')) {
      this.breadcrumbData?.splice(1, 1);
    }
    this.updateOrgNameAndAppName();
  }

  /**
 * Updates the breadcrumb labels with the organization and application names
 * based on the current URL and the user's role.
 * 
 * - Super Admin: Shows organization and application names.
 * - Organization Admin: Shows only the application name.
 * - Other users: Displays the application name if `applicationId` is present in the URL.
 */
  updateOrgNameAndAppName() {
    const currentUrl = this.router.url;
    const baseUrl = currentUrl.split('?')[0];
    if (baseUrl === '/home/customers') {
      if (this.breadcrumbData) {
          if (this.loggedInUserType === this.loggedInUser.superAdmin) {
              if (this.breadcrumbData[1]) {
                  this.breadcrumbData[1].label = 'Applications';
              }
          } else if (this.loggedInUserType === this.loggedInUser.organizationAdmin) {
              if (this.breadcrumbData[0]) {
                  this.breadcrumbData[0].label = 'Applications';
              }
          }
      }
    }
    if (currentUrl.includes('usermgmt') || currentUrl.includes('llm')) {
      return;
    }
    if (this.router.url && !this.router.url.includes('um') && this.breadcrumbData) {
      if (this.loggedInUserType === this.loggedInUser.superAdmin) {
        if (this.breadcrumbData.length > 1) {
          this.breadcrumbData[0].label = this.appStateService.getOrganizationInfo()?.customerName;
        }
        if (baseUrl !== '/home/customers' && this.breadcrumbData.length > 2) {
          this.breadcrumbData[1].label = this.appStateService.getApplicationInfo()?.applicationName;
        }
      } else if (this.loggedInUserType === this.loggedInUser.organizationAdmin) {
        if (baseUrl !== '/home/customers' && this.breadcrumbData.length > 1) {
          this.breadcrumbData[0].label = this.appStateService.getApplicationInfo()?.applicationName;
        }
      } else {
        const urlParams = new URLSearchParams(this.router.url.split('?')[1]);
        const applicationId = urlParams.get('applicationId');

        if (applicationId && this.breadcrumbData.length > 1) {
          this.breadcrumbData[0].label = this.appStateService.getApplicationInfo()?.applicationName;
        }
      }
    }
  }
  
/**
 * Updates the breadcrumb by removing the item with the specified label.
 * 
 * - Finds the index of the breadcrumb item with the given label.
 * - Removes the breadcrumb item if it exists.
 * 
 * @param label - The label of the breadcrumb item to be removed.
 */
  updateBreadcrumb(label: string) {
    const index = this.breadcrumbData?.findIndex((item: MenuItem) => item.label === label);
    if (index !== undefined && index !== -1) {
      this.utils.removeBreadCrumb(index);
    }
  }

  /**
 * Checks if the given breadcrumb item is the last item in the breadcrumb array.
 * 
 * @param item - The breadcrumb item to check.
 * @returns `true` if the item is the last one, otherwise `false`.
 */
  isLastItem(item: MenuItem): boolean {
    return this.breadcrumbData ? this.breadcrumbData.indexOf(item) === this.breadcrumbData.length - 1 : false;
  }
}
